import { headerConnect as connect } from 'components/Shared/connect';
import { Button } from 'components/Button';
import { setSiteMode } from 'store/appShell/actions';
import styles from './styles.scss';
import cn from 'classnames';
import { SiteMode } from 'models/SiteMode';
import { rm } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { IconSiteMode } from 'components/Shared/Icon/themes/BGH-RD3/iconSiteMode';

interface OwnProps {
  closeSiteModeModal?: () => void;
}

interface MergedProps extends OwnProps {
  setSiteMode: (value: SiteMode) => Promise<void>;
}

const siteModeSelector = ({ setSiteMode, closeSiteModeModal }: MergedProps) => {
  const changeSiteMode = (siteMode: SiteMode) => () => {
    void setSiteMode(siteMode).then(() => closeSiteModeModal && closeSiteModeModal());
  };

  return (
    <div className={styles.base}>
      <Button
        onClick={changeSiteMode(SiteMode.Private)}
        {...getQaDataAttr('sitemodeprivate')}
        className={styles.btn}
      >
        <IconSiteMode className={styles.icon} />
        {rm('checkout_folder_private')}
      </Button>
      <Button
        onClick={changeSiteMode(SiteMode.Company)}
        {...getQaDataAttr('sitemodecompany')}
        className={cn(styles.btn, styles.company)}
      >
        <IconSiteMode className={styles.icon} />
        {rm('checkout_folder_company')}
      </Button>
    </div>
  );
};

export const SiteModeSelector = connect<MergedProps, OwnProps>(
  ({ appShell }) => ({
    selectedMode: appShell.siteMode
  }),
  dispatch => ({
    setSiteMode: (value: SiteMode) => dispatch(setSiteMode(value))
  })
)(siteModeSelector);
